import { InstallAgentAdditionalTargetsFormView } from '../view/InstallAgentAdditionalTargetsFormView';
import { installAgentAdditionalTargetsForm } from '../view/template';
import { BaseWebComponentController } from '../../../../../framework/BaseWebComponentController';
import { InstallAgentAdditionalTargetsFormWebComponent } from '../component/InstallAgentAdditionalTargetsFormWebComponent';
import { AdditionalTargetsViewData } from '../types';

export class InstallAgentAdditionalTargetsFormController extends BaseWebComponentController {
  public component: InstallAgentAdditionalTargetsFormWebComponent;
  public view: InstallAgentAdditionalTargetsFormView;
  public viewConstructor: typeof InstallAgentAdditionalTargetsFormView;

  constructor(component: InstallAgentAdditionalTargetsFormWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: InstallAgentAdditionalTargetsFormView,
      viewTemplate: installAgentAdditionalTargetsForm,
    });
  }

  public async getDataForView(): Promise<AdditionalTargetsViewData> {
    return {
      hasNoCompanySelected: this.component.hasNoCompanySelected,
    };
  }
}
